import React from 'react';

const FuturePlans: React.FC = () => {
  return (
    <div className="future-plans">
      <h2>Future Features</h2>
      <p className="future-plans-intro">
        Here are some exciting features we're planning to add to Aloudit:
      </p>

      <div className="feature-list">
        <div className="feature-item">
          <div className="feature-icon">📄</div>
          <div className="feature-content">
            <h3>Long-Text TTS</h3>
            <p>Submit entire files or chapters for text-to-speech conversion, making it easier to listen to longer content without manual splitting.</p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">🔌</div>
          <div className="feature-content">
            <h3>More TTS Engine Integrations</h3>
            <p>Support for additional TTS providers like ElevenLabs and OpenAI, giving you more voice options and quality levels to choose from.</p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">🎭</div>
          <div className="feature-content">
            <h3>TTS Configuration Presets</h3>
            <p>Save and switch between different TTS configurations optimized for various languages, genres, or books. Quick-switch your preferred settings.</p>
          </div>
        </div>
      </div>

      <div className="future-plans-footer">
        <p>Have a feature request? Let us know!</p>
      </div>
    </div>
  );
};

export default FuturePlans;
